import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation } from "react-router-dom";
import { Header } from "./components/Header";
import { useParams, useNavigate } from "react-router-dom";
import { ShimmerTable } from "react-shimmer-effects";
import { NavLink } from "react-router-dom";
import Navbar from "./components/Navbar";
const API_URL = "/api";

export default function Searches() {
  const { id } = useParams();
  const location = useLocation();
  const [company, setCompany] = useState(null);
  const [formData, setFormData] = useState({});
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [updatedCompany, setUpdatedCompany] = useState(null);

  useEffect(() => {
    const fetchCompanyDetails = async () => {
      try {
        const response = await fetch(`${API_URL}/getComapnyProfile/${id}`);
        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);
        const data = await response.json();
        setCompany(data);
        setFormData(data);

        console.log("data:", data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchCompanyDetails();
  }, [id]);

  useEffect(() => {
    if (company?.COMPANYINFO?.COMPANYNAME_ENGLISH) {
      document.title = company.COMPANYINFO.COMPANYNAME_ENGLISH;
    } else {
      document.title = "Company Log"; // fallback
    }
    return () => {
      document.title = "Company Log";
    };
  }, [company]);

  function formatDate(dateString) {
    if (!dateString) return ""; // null, undefined, empty string

    const date = new Date(dateString);

    // Check for invalid date
    if (isNaN(date.getTime())) return "";

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${month}/${day}/${year}`;
  }

  function formatDateMM(dateString) {
    if (!dateString) return "N/A";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, "0");
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  }

  function getDaysDifference(targetDateString) {
    const today = new Date();
    const targetDate = new Date(targetDateString);

    // Reset time components to ignore hours/minutes/seconds
    today.setHours(0, 0, 0, 0);
    targetDate.setHours(0, 0, 0, 0);

    const diffInMs = today - targetDate;
    const diffInDays = Math.round(diffInMs / (1000 * 60 * 60 * 24));

    return diffInDays;
  }

  const navigate = useNavigate();

  return (
    <div className="app-container">
      <div className="container-fluid">
        <main className="content">
          <div className="row">
            <Navbar />
            <div className="col-md-10" style={{ marginTop: "30px" }}>
              <NavLink to={`/Dashboard`} className="btn btn-dark ms-2">
                Back to Company Log
              </NavLink>

              <br />
              <br />

              <NavLink
                to={`/details/${id}`}
                className="btn btn-outline-secondary ms-2"
              >
                Company Information
              </NavLink>

              <NavLink
                to={`/DocumentCheckList/${id}`}
                className="btn btn-outline-secondary ms-2"
              >
                Document Checklist
              </NavLink>

              <NavLink to={`/Searches/${id}`} className="btn btn-dark ms-2">
                Searches
              </NavLink>

              <NavLink
                to={`/FinancialAnalysis/${id}`}
                className="btn btn-outline-secondary ms-2"
              >
                Financial Analysis
              </NavLink>

              <NavLink
                to={`/CompanyScore/${id}`}
                className="btn btn-outline-secondary ms-2"
              >
                Company Score
              </NavLink>

              <NavLink
                to={`/ScoringCriteria/${id}`}
                className="btn btn-outline-secondary ms-2"
              >
                Scoring Criteria
              </NavLink>

              <div className="d-flex justify-content-between align-items-center mb-3">
                <h3 style={{ marginTop: "10px" }}>
                  Searches
                  <span
                    style={{
                      paddingLeft: "20px",
                      color: "red",
                      fontSize: "20px",
                      fontWeight: "bold",
                    }}
                  >
                    {company?.VersionString}
                  </span>
                </h3>
              </div>

              {loading ? (
                <ShimmerTable row={5} col={5} />
              ) : (
                <>
                  <table className="table table-bordered">
                    <tr>
                      <td style={{ width: "50%" }}>Company Name:</td>
                      <td
                        style={{
                          width: "50%",
                          textAlign: "center",
                        }}
                      >
                        {company?.COMPANYINFO?.COMPANYNAME_ENGLISH}
                      </td>
                    </tr>
                    <tr>
                      <td>BR Number:</td>
                      <td
                        style={{
                          width: "50%",
                          textAlign: "center",
                        }}
                      >
                        {company?.COMPANYINFO?.BUSINESSREGISTRATIONNUMBER}
                      </td>
                    </tr>
                    <tr>
                      <td>Date</td>
                      <td
                        style={{
                          width: "50%",
                          textAlign: "center",
                        }}
                      >
                        {company?.ReviewByData?.DATE &&
                        company?.ReviewByData?.DATE !== null
                          ? formatDateMM(company?.ReviewByData?.DATE)
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>Date Reviewed</td>
                      <td
                        style={{
                          width: "50%",
                          textAlign: "center",
                        }}
                      >
                        {" "}
                        {company?.ReviewByData?.DATE_REVIEW &&
                        company?.ReviewByData?.DATE_REVIEW !== null
                          ? formatDateMM(company?.ReviewByData?.DATE_REVIEW)
                          : ""}
                      </td>
                    </tr>
                  </table>

                  <h4>Winding-up & Litigation Checks</h4>
                  <table className="table table-bordered">
                    <tr
                      style={{
                        backgroundColor: "#173660",
                        color: "#fff",
                        textAlign: "center",
                        height: "40px",
                      }}
                    >
                      <th>Criteria</th>
                      <th>Checking Details</th>
                      <th>N/A</th>
                      <th>Comments</th>
                      <th style={{ backgroundColor: "red" }}>Red Flag</th>
                    </tr>
                    <tr>
                      <td>
                        Performed Winding-up and bankruptcy checks for company
                      </td>
                      <td></td>
                      <td
                        style={{
                          backgroundColor: "#58a65c",
                          color: "#fff",
                          textAlign: "center",
                        }}
                      >
                        {company?.WINDINGUP_LITIGATION_CHECKS?.[0]?.NA || "N/A"}
                      </td>
                      <td
                        style={{
                          backgroundColor: "#fdf3d0",
                          textAlign: "center",
                        }}
                      ></td>
                      <td
                        style={{
                          backgroundColor: "#e3e3e3",
                          textAlign: "center",
                        }}
                      ></td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "right" }}>Enter Date: </td>
                      <td
                        style={{
                          backgroundColor: "#fdf3d0",
                          color: "#000",
                          textAlign: "right",
                        }}
                      >
                        {company?.WINDINGUP_LITIGATION_CHECKS?.[0]?.EntreDate
                          ? formatDate(
                              company.WINDINGUP_LITIGATION_CHECKS[0].EntreDate
                            )
                          : ""}
                      </td>
                      <td></td>
                      <td
                        style={{
                          backgroundColor: "#dce9d5",
                          textAlign: "center",
                        }}
                      >
                        {company?.WINDINGUP_LITIGATION_CHECKS?.[0]?.EntreDate
                          ? `Days since review: ${getDaysDifference(
                              company.WINDINGUP_LITIGATION_CHECKS[0].EntreDate
                            )}`
                          : ""}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                        }}
                      ></td>
                    </tr>

                    <tr>
                      <td>
                        Performed Directors’ bankruptcy checks (if ID is
                        available)
                      </td>
                      <td></td>
                      <td
                        style={{
                          backgroundColor: "#58a65c",
                          color: "#fff",
                          textAlign: "center",
                        }}
                      >
                        {company?.WINDINGUP_LITIGATION_CHECKS?.[1]?.NA || "N/A"}
                      </td>
                      <td
                        style={{
                          backgroundColor: "#fdf3d0",
                          textAlign: "center",
                        }}
                      ></td>
                      <td
                        style={{
                          backgroundColor: "#e3e3e3",
                          textAlign: "center",
                        }}
                      ></td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "right" }}>Enter Date: </td>
                      <td
                        style={{
                          backgroundColor: "#fdf3d0",
                          color: "#000",
                          textAlign: "right",
                        }}
                      >
                        {company?.WINDINGUP_LITIGATION_CHECKS?.[1]?.EntreDate
                          ? formatDate(
                              company.WINDINGUP_LITIGATION_CHECKS[1].EntreDate
                            )
                          : ""}
                      </td>
                      <td></td>
                      <td
                        style={{
                          backgroundColor: "#dce9d5",
                          textAlign: "center",
                        }}
                      >
                        {company?.WINDINGUP_LITIGATION_CHECKS?.[1]?.EntreDate
                          ? `Days since review: ${getDaysDifference(
                              company.WINDINGUP_LITIGATION_CHECKS[1].EntreDate
                            )}`
                          : ""}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                        }}
                      ></td>
                    </tr>

                    <tr>
                      <td>Performed Litigation check</td>
                      <td></td>
                      <td
                        style={{
                          backgroundColor: "#58a65c",
                          color: "#fff",
                          textAlign: "center",
                        }}
                      >
                        {company?.WINDINGUP_LITIGATION_CHECKS?.[2]?.NA || "N/A"}
                      </td>
                      <td
                        style={{
                          backgroundColor: "#fdf3d0",
                          textAlign: "center",
                        }}
                      ></td>
                      <td
                        style={{
                          backgroundColor: "#e3e3e3",
                          textAlign: "center",
                        }}
                      ></td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "right" }}>Enter Date: </td>
                      <td
                        style={{
                          backgroundColor: "#fdf3d0",
                          color: "#000",
                          textAlign: "right",
                        }}
                      >
                        {formatDate(
                          company?.WINDINGUP_LITIGATION_CHECKS?.[2]?.EntreDate
                        )}
                      </td>
                      <td></td>
                      <td
                        style={{
                          backgroundColor: "#dce9d5",
                          textAlign: "center",
                        }}
                      >
                        {company?.WINDINGUP_LITIGATION_CHECKS?.[2]?.EntreDate
                          ? `Days since review: ${getDaysDifference(
                              company.WINDINGUP_LITIGATION_CHECKS[0].EntreDate
                            )}`
                          : ""}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                        }}
                      ></td>
                    </tr>
                  </table>

                  <h4>Charges Register</h4>
                  <table className="table table-bordered">
                    <tr
                      style={{
                        backgroundColor: "#173660",
                        color: "#fff",
                        textAlign: "center",
                        height: "40px",
                      }}
                    >
                      <th>Criteria</th>
                      <th>Checking Details</th>
                      <th>N/A</th>
                      <th>Comments</th>
                      <th style={{ backgroundColor: "red" }}>Red Flag</th>
                    </tr>
                    <tr>
                      <td>
                        {company?.ChargesRegister?.[0]?.Criteria || "N/A"}
                      </td>
                      <td></td>
                      <td
                        style={{
                          backgroundColor: "#58a65c",
                          color: "#fff",
                          textAlign: "center",
                        }}
                      >
                        {company?.ChargesRegister?.[0]?.NA}
                      </td>
                      <td
                        style={{
                          backgroundColor: "#fdf3d0",
                          textAlign: "center",
                        }}
                      ></td>
                      <td
                        style={{
                          backgroundColor: "#e3e3e3",
                          textAlign: "center",
                        }}
                      ></td>
                    </tr>
                    <tr>
                      <td style={{ textAlign: "right" }}>Enter Date: </td>
                      <td
                        style={{
                          backgroundColor: "#fdf3d0",
                          color: "#000",
                          textAlign: "right",
                        }}
                      >
                        {formatDate(company?.ChargesRegister?.[0]?.EntreDate)}
                      </td>
                      <td></td>
                      <td
                        style={{
                          backgroundColor: "#dce9d5",
                          textAlign: "center",
                        }}
                      >
                        {company?.ChargesRegister?.[0]?.EntreDate
                          ? `Days since review: ${getDaysDifference(
                              company?.ChargesRegister?.[0]?.EntreDate
                            )}`
                          : ""}
                      </td>
                      <td
                        style={{
                          textAlign: "center",
                        }}
                      ></td>
                    </tr>
                  </table>
                </>
              )}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}
